import React from 'react';
import classnames from 'clsx';
import { get } from 'lodash-es';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Button } from 'ui-components/components/button';
import { noop } from 'ui-components/default-props/noop';
import FormattedCurrency from '../../../../components/formatted-currency';
import { CurrencySymbolContainer } from '../../../../containers/currency-symbol-container';
import { RateBrowserRatePropType } from '../../../../prop-types/rate-browser-rate';
import { DateService } from '../../../../services/date-service';
import Global from '../../../../store/global-selectors';
import style from './rate-list-item.module.less';
import { RateWarningType } from '../rate-warning-type';
import { messages } from '../../messages';
import { emptyObject } from 'ui-components/default-props/empty';

const RateListItem = ({ rate = emptyObject, onClick = noop, selected = false, className = '' }) => {
  const { serviceId, packageTypeId, warning, packageCount } = rate;
  const { carrierId } = useSelector((state) => Global.selectSellerServiceById(state, { serviceId }));
  const foundPackage = useSelector((state) =>
    Global.selectSellerPackages(state)
      .filter(({ carrierId: packageCarrierId }) => packageCarrierId === carrierId)
      .find(({ packageTypeId: ptId }) => ptId === packageTypeId),
  );
  const { name: packageName, packageId } = foundPackage || {};
  const topLevelClassName = classnames(style['rate-list-item'], className, {
    [style.selected]: selected,
  });
  // todo handle various ship dates
  const { estimatedDeliveryTime, rateName } = rate;
  const innerRate = rate.rate;
  // todo make formatted currency container to get the default currency
  const totalCost = get(innerRate, 'totalCost', { value: 0, code: 'USD' });
  const { value, code } = totalCost;
  const formattedDeliveryTime = DateService.formatDateFromRateDate(estimatedDeliveryTime);
  return (
    <Button className={topLevelClassName} onClick={() => onClick({ ...rate, packageId })} theme='unstyled'>
      <div className={style['rate-information']}>
        <div className={style['rate-name']}>{rateName}</div>
        <div className={style['rate-meta']}>
          {packageCount > 1 ? (
            <FormattedMessage {...messages.multiPackageRateViewerCaption} values={{ count: packageCount }} />
          ) : (
            packageName
          )}
        </div>
        {formattedDeliveryTime && (
          <div className={style['rate-meta']}>
            <FormattedMessage
              defaultMessage='Est. Delivery {estimatedTime}'
              description='rateListItem.estimatedDelivery'
              id='3nbzGw'
              values={{ estimatedTime: formattedDeliveryTime }}
            />
          </div>
        )}
      </div>
      <div className={style['rate-value']}>
        {warning === RateWarningType.NotSupported ? (
          <>
            <CurrencySymbolContainer currencyCode={code} />-
          </>
        ) : (
          <FormattedCurrency currencyCode={code} value={value} />
        )}
      </div>
    </Button>
  );
};

RateListItem.propTypes = {
  rate: RateBrowserRatePropType,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  className: PropTypes.string,
};

export default RateListItem;
